import $ from 'jquery'

export const triggerActiveTabChanged = (tabNum) => {
    $(document).trigger('userManagement_userList_activeTabChanged', [tabNum])
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/syncCallbacks.js